import apiSlice from '../../services/api/slice'

const usersSlice = apiSlice.injectEndpoints({
  name: 'users',
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: () => ({ url: '/v1/admin/users' }),
      transformResponse: (response) => response.data.map((user) => ({ ...user, id: user.sub })),
      providesTags: ['Users'],
    }),
    putUser: builder.mutation({
      query: (user) => ({
        url: `/v1/admin/users/${user.sub}`,
        method: 'PUT',
        body: user,
      }),
      invalidatesTags: ['Users'],
    }),
    disableUser: builder.mutation({
      query: (user) => ({
        url: `/v1/admin/users/${user.sub}/disable`,
        method: 'PUT',
      }),
      invalidatesTags: ['Users'],
    }),
    enableUser: builder.mutation({
      query: (user) => ({
        url: `/v1/admin/users/${user.sub}/enable`,
        method: 'PUT',
      }),
      invalidatesTags: ['Users'],
    }),
    postUser: builder.mutation({
      query: (user) => ({
        url: '/v1/admin/users',
        method: 'POST',
        body: user,
      }),
      invalidatesTags: ['Users'],
    }),
    deleteUser: builder.mutation({
      query: (user) => ({
        url: `/v1/admin/users/${user.sub}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Users'],
    }),
  }),
})

export const {
  useGetUsersQuery,
  usePutUserMutation,
  useDisableUserMutation,
  useEnableUserMutation,
  usePostUserMutation,
  useDeleteUserMutation,
} = usersSlice

export default usersSlice
